<div class="row justify-content-center">
  <div class="col-auto">
    <fa-layers [fixedWidth]="true" size="9x">
      <fa-icon class="icon-file" [icon]="faFile" transform="shrink-4 left-9.5 up-3 rotate--35"></fa-icon>
      <fa-icon class="icon-question" [icon]="faQuestion" transform="shrink-12 left-9 up-2.25 rotate--35"></fa-icon>
      <fa-icon class="text-danger" [icon]="faSquare"></fa-icon>
      <fa-icon [icon]="randomIcon.icon" [inverse]="true" transform="shrink-10"></fa-icon>
      <fa-icon class="icon-file" [icon]="faFile" transform="shrink-4 right-9.5 down-4 rotate-25"></fa-icon>
      <fa-icon class="icon-question" [icon]="faQuestion" transform="shrink-12 right-9 down-5 rotate-25"></fa-icon>
    </fa-layers>
  </div>
</div>
<div class="row text-center pb-3">
  <div class="col">
    <h2 class="fw-black">Sorry, we looked everywhere...</h2>
    <h5 class="text-secondary fw-normal">The requested page <b>{{ path }}</b> was not found, but we did find this
      {{randomIcon.name}}!</h5>
    <div class="text-secondary">You are seeing this because the page was moved, deleted, misspelled, or never existed.</div>
  </div>
</div>
<div class="row justify-content-center py-3">
  <div class="col-auto">
    <a class="btn btn-primary" [routerLink]="goBackUrlPath" [queryParams]="goBackUrlParams">Go Back to {{goBackName}}</a>
  </div>
</div>
<div class="row text-center pt-3">
  <div class="col text-secondary">
    If you feel this is a mistake, contact support.
  </div>
</div>
